module.exports = __webpack_public_path__ + "img/companyregistrationcertificateZh.236d189f.jpg";